<template>
  <div class="radiokt-container">
    <div class="radio-event-box">
      <RadioEventBox :imgurl="`/media/images/landing/kakaoevent-landing.png`" />
    </div>
  </div>
</template>
<script>
import RadioEventBox from '@/components/radioktevent/RadioKtEventBox.vue';

export default {
  components: {
    RadioEventBox
  },
  data() {
    return {
      app: null
    };
  },
  mounted() {
    this.app = document.querySelector('.app');
    this.app.classList.add('radioktevent');
  },
  unmounted() {
    this.app.classList.remove('radioktevent');
  }
};
</script>
<style scoped>
.radiokt-container {
  height: 100%;
  background-color: var(--111111);
  overflow: auto;
}
.radio-event-box {
  max-width: 768px;
  width: 100%;
  margin: 0 auto;
}
</style>
